import {
  getPaymentFeeForActivePaywayAsNumber,
  isPaymentFeeActive,
  isPaymentFeeLegacyMode,
} from '@/base/domain/paymentFee.domain'

export const getTransactionAmount = ({
  paymentData = null,
  confirmationData = null,
  paywayID = null,
} = {}) => {
  const baseAmount = Number(paymentData?.transaction?.payAmount) || 0

  if (!isPaymentFeeActive({ paymentData, confirmationData }) || isPaymentFeeLegacyMode(paymentData)) {
    return baseAmount
  }

  return baseAmount + getPaymentFeeForActivePaywayAsNumber({ paymentData, paywayID })
}
